import { cn, Tooltip, Typography } from "@kyan/ui";

import { type TradeFeeProps } from "#/types/fees";
import { formatValue } from "#/utils/valueFormatters";

import { tradeFeeItems } from "./TradeFee.constants";
import { useTradeFeeController } from "./TradeFee.controller";

export const TradeFee: React.FC<TradeFeeProps> = (props) => {
  const fees = useTradeFeeController(props);

  return (
    <div className="flex justify-between">
      <Typography grotesk size={12}>
        Estimated fee
      </Typography>

      <Tooltip
        className="w-40"
        content={
          <div className="flex flex-col gap-4">
            {tradeFeeItems.map(({ key, label }) => (
              <div key={key} className="flex justify-between">
                <span>{label}</span>
                <div className="flex gap-1">
                  <span className="dark:text-white">
                    {formatValue(fees[key])}
                  </span>
                  USD
                </div>
              </div>
            ))}
          </div>
        }
      >
        <div className="flex gap-1">
          <Typography
            grotesk
            size={12}
            className={cn({
              "cursor-help dark:text-white": !Number.isNaN(fees.totalFee),
            })}
          >
            {Number.isNaN(fees.totalFee) ? "-" : formatValue(fees.totalFee)}
          </Typography>
          <Typography grotesk size={12}>
            {Number.isNaN(fees.totalFee) ? "-" : "USD"}
          </Typography>
        </div>
      </Tooltip>
    </div>
  );
};
